export const emailVal = (value) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(value).toLowerCase())
    ? undefined
    : 'Digite um e-mail válido'
}

export const emailConfVal = (email, confEmail) => {
  if (email?.match(/@/gi)?.length !== 1) return 'Os e-mails devem ser iguais'
  return email !== confEmail ? 'Os e-mails devem ser iguais' : undefined
}

export const passVal = (value) =>
  (value?.length || 0) < 6 ? 'Senha deve ter mais de 6 digitos' : undefined

export const passConfVal = (pass, passConf) =>
  pass !== passConf
    ? 'Senha e confirmação de senha devem ser iguais'
    : undefined

const validarCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '')
  if (cpf === '') return false
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false
  let add = 0
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i)
  let rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(cpf.charAt(9))) return false
  let add2 = 0
  for (let i = 0; i < 10; i++) add2 += parseInt(cpf.charAt(i)) * (11 - i)
  let rev2 = 11 - (add2 % 11)
  if (rev2 === 10 || rev2 === 11) rev2 = 0
  if (rev2 !== parseInt(cpf.charAt(10))) return false
  return true
}

export const cpfVal = (value) => {
  if (value === undefined) return undefined
  value = value?.replace(/[^\d]+/g, '')
  if ((value?.length || 0) < 11) return 'CPF deve ser composto de 11 dígitos'
  return validarCPF(value) ? undefined : 'CPF inválido'
}

export const birthVal = (value) => {
  if (value === undefined) return undefined
  if ((value?.length || 0) < 10) return 'Data de nascimento obrigatória'
  const dates = value?.split('/') || []
  if (+dates[0] < 1 || +dates[0] > 31)
    return 'O dia de nascimento deve ser entre 01 e 31'
  if (+dates[1] < 1 || +dates[1] > 12)
    return 'O mês de nascimento deve ser entre 01 e 12'
  if (+dates[2] < 1900 || +dates[2] > 2021)
    return 'Favor preencher com ano válido'
  return undefined
}

export const cellVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 15 ? 'Número de celular incompleto' : undefined
}

// export const fixPhoneVal = (value) => {
//   if (value === undefined)
//     return undefined(value?.length || 0) < 14 && (value?.length || 0) > 0
//       ? 'Número de telefone incompleto'
//       : undefined
// }

export const fixPhoneVal = (value) =>
  (value?.length || 0) < 14 && (value?.length || 0) > 0
    ? 'Número de telefone incompleto'
    : undefined

export const nameVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 7 ? 'Preencher com nome nompleto' : undefined
}

export const preNameVal = (value) => {
  // if (value === undefined)
  //   return undefined(value?.length || 0) < 1
  //     ? 'Preencher com apelido ou nome'
  //     : undefined
  if (value === undefined) return undefined
  return (value?.length || 0) < 1 ? 'Preencher com apelido' : undefined
}

export const fieldVal = (arr, val) => {
  let message = ''
  for (let i = 0; i < arr.length; i++) {
    if (val[i](arr[i])) message += val[i](arr[i]) + '. '
  }
  return message
}

export const fieldValComp = (arr, val) => {
  let message = ''
  for (let i = 0, k = 0; i < val.length; i++, k += 2) {
    if (val[i](arr[k], arr[k + 1])) message += val[i](arr[k], arr[k + 1]) + '. '
  }
  return message
}
